import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import AgencyCart from "./SmallComps/AgencyCart";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingFull } from "../LoadingFull";
import { Loading } from "../Loading";
import { setMetaTags } from "../Functions/SetHeaders";
import { paramsToObject } from "../Functions/Helpers";
import EndObserver from "../Functions/EndObserver";

const Styles = styled.div`
  width: calc(100% - calc(var(--universal-pad) * 2));
  margin: 0 var(--universal-pad) 1rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  @media screen and (max-width: 850px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

function BrokerFilter36(props) {
  const { vars, lan, pageDataMeta } = props;
  console.log(pageDataMeta);
  const location = useLocation();
  const navigate = useNavigate();
  const [baseSearch, setBaseSearch] = useState(location.search);
  const [pageData, setPageData] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingS, setLoadingS] = useState(false);
  const [paginate, setPaginate] = useState(6);
  const [page, setPage] = useState(1);

  const paramsBase = new URLSearchParams(baseSearch);
  const params = paramsToObject(paramsBase);

  useEffect(() => {
    getData(true);
  }, []);

  useEffect(() => {
    if (location.search !== baseSearch) {
      setBaseSearch(location.search);
    }
  }, [location.search]);

  useEffect(() => {
    getData(false);
  }, [baseSearch]);

  const getData = async (isLoading = false) => {
    if (isLoading) {
      setLoading(true);
    }
    setLoadingS(true);

    let URLparams = new URLSearchParams();
    let availableVal = ["Agency_Name", "Country_Id", "City_Id", "page", "rows"];

    for (let i = 0; i < availableVal.length; i++) {
      const element = availableVal[i];
      if (paramsBase.get(element)) {
        URLparams.append(element, paramsBase.get(element));
      }
    }

    if (!paramsBase.get("rows")) {
      URLparams.append("rows", 6);
    }

    // travel-agency URL
    if (location.pathname.includes("travel-agency")) {
      URLparams.append("Agency_Type_Id", 1);
    } else {
      URLparams.append("Agency_Type_Id", 2);
    }

    if (vars.Continent_Url)
      URLparams.append("Continent_Url", vars.Continent_Url);
    if (vars.Country_Url) URLparams.append("Country_Url", vars.Country_Url);

    let newpage = parseInt(URLparams.get("page"));
    let newrows = parseInt(URLparams.get("rows"));

    if (pageData.length !== (newpage - 1) * newrows) {
      let temp = { ...params };
      temp["page"] = 1;
      temp["rows"] = 6;
      setPage(1);
      setPaginate(6);

      let URLparams2 = new URLSearchParams();
      for (let i = 0; i < Object.keys(temp).length; i++) {
        const element = Object.keys(temp)[i];
        if (temp[element]) {
          URLparams2.append(element, temp[element]);
        }
      }
      navigate(location.pathname + "?" + URLparams2.toString(), {
        replace: true,
      });
      return;
    }

    const response = await GetDataPromise(
      `${apiMain}/api/v1/agencies/agency/searchname?${URLparams.toString()}`
    );
    const parsed = JSON.parse(response);

    if (
      (parsed.status &&
        parsed.status !== "error" &&
        parsed.status !== "error-no-internet") ||
      parsed.status === "success"
    ) {
      if (parsed.data.data.length) {
        let tempData = [...pageData];
        if (tempData.length < parsed.data.from) {
          tempData.push(...parsed.data.data);
        }
        setPageData(tempData);
        setMeta({
          ...parsed.data,
          data: [],
        });
        setPage(parsed.data.current_page);
        setPaginate(parseInt(parsed.data.per_page));

        let title = "Agencies";
        const isTourOperator = location.pathname.includes("tour-operator");

        if (isTourOperator) {
          title =
            lan.filename === "fa"
              ? ` کارگزار تور ${pageDataMeta.Country?.Country_Name || ""}`
              : ` ${
                  pageDataMeta.Country?.Country_En_Name || ""
                } Tour operators`;
        } else {
          title =
            lan.filename === "fa"
              ? `آژانس های مسافرتی ${pageDataMeta.Country?.Country_Name || ""}`
              : ` ${
                  pageDataMeta.Country?.Country_En_Name || ""
                } Travel Agencies`;
        }

        if (
          !pageDataMeta.Country?.Country_Name &&
          pageDataMeta.Continent?.Continent_FaName
        ) {
          title =
            lan.filename === "fa"
              ? `آژانس های مسافرتی  ${pageDataMeta.Continent.Continent_FaName}`
              : `  ${pageDataMeta.Continent.Continent_EnName} Travel Agencies`;
        }

        if (
          !pageDataMeta.Country?.Country_Name &&
          pageDataMeta.Continent?.Continent_FaName &&
          isTourOperator
        ) {
          title =
            lan.filename === "fa"
              ? `کارگزار تور  ${pageDataMeta.Continent.Continent_FaName}`
              : `  ${pageDataMeta.Continent.Continent_EnName} Tour operators`;
        }

        setMetaTags(title, "", "noindex");

        setLoading(false);
        setLoadingS(false);
        return;
      }
      let title = "Agencies";
      const isTourOperator = location.pathname.includes("tour-operator");

      if (isTourOperator) {
        title =
          lan.filename === "fa"
            ? ` کارگزار تور ${pageDataMeta.Country?.Country_Name || ""}`
            : ` ${pageDataMeta.Country?.Country_En_Name || ""} Tour operators`;
      } else {
        title =
          lan.filename === "fa"
            ? `آژانس های مسافرتی ${pageDataMeta.Country?.Country_Name || ""}`
            : ` ${pageDataMeta.Country?.Country_En_Name || ""} Travel Agencies`;
      }

      if (
        !pageDataMeta.Country?.Country_Name &&
        pageDataMeta.Continent?.Continent_FaName
      ) {
        title =
          lan.filename === "fa"
            ? `آژانس های مسافرتی  ${pageDataMeta.Continent.Continent_FaName}`
            : `  ${pageDataMeta.Continent.Continent_EnName} Travel Agencies`;
      }

      if (
        !pageDataMeta.Country?.Country_Name &&
        pageDataMeta.Continent?.Continent_FaName &&
        isTourOperator
      ) {
        title =
          lan.filename === "fa"
            ? `کارگزار تور  ${pageDataMeta.Continent.Continent_FaName}`
            : `  ${pageDataMeta.Continent.Continent_EnName} Tour operators`;
      }

      setLoading(false);
      setLoadingS(false);
      setMetaTags(title, "", "noindex");
      return;
    }

    let title = "Agencies";
    const isTourOperator = location.pathname.includes("tour-operator");

    if (isTourOperator) {
      title =
        lan.filename === "fa"
          ? ` کارگزار تور ${pageDataMeta.Country?.Country_Name || ""}`
          : ` ${pageDataMeta.Country?.Country_En_Name || ""} Tour operators`;
    } else {
      title =
        lan.filename === "fa"
          ? `آژانس های مسافرتی ${pageDataMeta.Country?.Country_Name || ""}`
          : ` ${pageDataMeta.Country?.Country_En_Name || ""} Travel Agencies`;
    }

    if (
      !pageDataMeta.Country?.Country_Name &&
      pageDataMeta.Continent?.Continent_FaName
    ) {
      title =
        lan.filename === "fa"
          ? `آژانس های مسافرتی  ${pageDataMeta.Continent.Continent_FaName}`
          : `  ${pageDataMeta.Continent.Continent_EnName} Travel Agencies`;
    }

    if (
      !pageDataMeta.Country?.Country_Name &&
      pageDataMeta.Continent?.Continent_FaName &&
      isTourOperator
    ) {
      title =
        lan.filename === "fa"
          ? `کارگزار تور  ${pageDataMeta.Continent.Continent_FaName}`
          : `  ${pageDataMeta.Continent.Continent_EnName} Tour operators`;
    }

    setPageData([]);
    setLoading(false);
    setLoadingS(false);
    setMetaTags(title, "", "noindex");
  };

  const loadMore = () => {
    if (loadingS || loading) {
      return;
    }
    let temp = { ...params };
    let newPage = page + 1;
    let pagination = paginate;
    if (newPage > meta.last_page) {
      return;
    }
    temp["page"] = newPage;
    temp["rows"] = pagination;
    setPage(newPage);
    setPaginate(pagination);
    let URLparams = new URLSearchParams();
    for (let i = 0; i < Object.keys(temp).length; i++) {
      const element = Object.keys(temp)[i];
      if (temp[element]) {
        URLparams.append(element, temp[element]);
      }
    }
    navigate(location.pathname + "?" + URLparams.toString());
  };

  if (loading) {
    return <LoadingFull />;
  }

  const makeItems = () => {
    if (!pageData.length) {
      return (
        <div className="no-match">
          {lan.filename === "fa"
            ? "آژانسی وجود ندارد."
            : "No agencies found."}
        </div>
      );
    }
    let items = pageData.map((v, i) => {
      return <AgencyCart v={v} i={i} key={i} lan={lan} />;
    });
    return (
      <>
        {items}
        {loadingS ? <Loading /> : <EndObserver func={loadMore} />}
      </>
    );
  };

  return <Styles>{makeItems()}</Styles>;
}

export default BrokerFilter36;
